import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>Soluções em Sistemas</h1>
            </header>
            <div className="content">
                <p>Com base em necessidades especificas</p>
                <ul className="actions">
                    <li><a href="/about" className="button next scrolly">saiba mais</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner
